"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _difference_in_calendar_days = _interopRequireDefault(require("date-fns/difference_in_calendar_days"));

var _distance_in_words_strict = _interopRequireDefault(require("date-fns/distance_in_words_strict"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _emotion = require("emotion");

var textStyle = function textStyle(isMobile) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:#4780ff;font-size:14px;", isMobile && "\n      font-size: 12px;\n      margin-top: 10px;")
  );
};

var AvailabiltyInfo = function AvailabiltyInfo(_ref) {
  var availableOn = _ref.availableOn,
      isMobile = _ref.isMobile;
  var text = '';
  text = "Available on ".concat((0, _format.default)(new Date(availableOn), 'Do MMM, hh:mm a'));
  /* if (differenceInCalendarDays(new Date(availableOn), new Date()) < 8) {
    text = `Available in ${distanceInWordsStrict(new Date(), new Date(availableOn))}`;
  } else { */

  /* } */

  return _react.default.createElement("div", {
    className: textStyle(isMobile)
  }, text);
};

var _default = AvailabiltyInfo;
exports.default = _default;